import { challengeRouteLoopProgress, } from "../challenge-presentation.js";
import { routeAwards } from "./award-model.js";
import { streakAward } from "./streak-award.js";
const DEFAULT_REACH_LIMIT = 3;
/** A profile shows at most this many earned medals, the most recent first. */
export const PROFILE_MEDAL_LIMIT = 10;
/**
 * What a profile shows of a member's medals. Preview medals are on routes the
 * member cannot join, so they are never "within reach".
 */
export function profileAwardHighlights(awards, options = {}) {
    const reached = awards.filter((award) => award.status === "reached");
    const earned = options.earnedLimit === undefined
        ? reached
        : [...reached].sort(byMostRecentlyReached).slice(0, options.earnedLimit);
    if (reached.length)
        return { earned, earnedTotal: reached.length, withinReach: [] };
    const withinReach = awards
        .filter((award) => award.status === "in-progress" || award.status === "available")
        // Stable sort: equal progress keeps collection order, so the current
        // route's first waypoint leads when nothing has been walked yet.
        .sort((left, right) => (right.progress ?? 0) - (left.progress ?? 0))
        .slice(0, options.reachLimit ?? DEFAULT_REACH_LIMIT);
    return { earned, earnedTotal: 0, withinReach };
}
/** ISO strings compare as text; a medal with no recorded date sorts after every dated one. */
const reachedKey = (award) => award.reached?.reachedAt ?? award.reached?.reachedOn ?? "";
function byMostRecentlyReached(left, right) {
    return reachedKey(right).localeCompare(reachedKey(left));
}
export function memberProfileAwards(profile) {
    const routeMedals = profile.awardRoutes.flatMap((entry) => routeAwards(entry.route, entry.enrollment, entry.milestoneHistory, { joinable: false }));
    // Only the best run matters here; the current one is the member's own business.
    const streak = streakAward({
        streakDays: 0,
        bestStreakDays: profile.bestStreakDays,
        restDay: { todayDeclared: false },
    });
    return [...routeMedals, streak];
}
/**
 * The route a teammate is walking right now, or null when every route they
 * have walked is finished (or they have walked none). Only one route is open
 * at a time, so the first unfinished enrollment is the one.
 */
export function memberRoutePosition(profile) {
    for (const { route, enrollment } of profile.awardRoutes) {
        if (!enrollment || enrollment.status === "completed")
            continue;
        return { routeName: route.name, progress: challengeRouteLoopProgress(enrollment) };
    }
    return null;
}
/** Routes the teammate has walked end to end at least once. */
export function memberRoutesCompleted(profile) {
    return profile.awardRoutes.filter(({ enrollment }) => enrollment !== null &&
        (enrollment.status === "completed" || enrollment.progress >= enrollment.target)).length;
}
//# sourceMappingURL=profile-awards.js.map